import realpressMedia from '../mixins/media';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	realpressMedia();
} );
